const POPUP_PORTAL_ID = "popup-portal";

export default POPUP_PORTAL_ID;
